import { render } from "./AddVesselModal.vue?vue&type=template&id=ba953274"
import script from "./AddVesselModal.vue?vue&type=script&lang=js"
export * from "./AddVesselModal.vue?vue&type=script&lang=js"

import "./AddVesselModal.vue?vue&type=style&index=0&id=ba953274&lang=css"
script.render = render

export default script